
import { useTranslation } from "react-i18next";
import { Maintenance } from "@fce-bees/fce-common-components";

export function MaintenancePage() {
  const { t } = useTranslation();

  const contactConfig = {
    header: t("maintenance.contactHeader"),
    text: t("maintenance.contactText"),
    button: t("maintenance.contactButton"),
    link: t("links.faqLink")
  };

  return (
    <Maintenance header={t("maintenance.title")} subheader={t("maintenance.subtitle")} contact={contactConfig} />
  );
}
